import { FC, useState, useCallback } from 'react';
import { Settings } from '@clds/icon';
import { PrimaryMenuItemMobile } from '../../components/PrimaryMenu';
import { HelpDropdownMenuMobile } from '../HelpDropdownMenu/HelpDropdownMenuMobile';
import { MENU_ITEM_ICON_SIZE } from '../../ApplicationWrapper.const';
import { UserDropdownMenuMobile } from '../UserDropdownMenu/UserDropdownMenuMobile';
import { useCustomerIdContext } from '../../context';
import { useApplicationWrapperContext } from '../../context/applicationWrapper/ApplicationWrapper.context';
import { ApplicationsDropdownButtonMobile } from '../DefaultApplicationsDropdown/ApplicationsDropdownButton/ApplicationsDropdownButtonMobile';
import { BottomPrimaryMenuItemsProps } from './BottomPrimaryMenuItems.types';
import { getSettingsHref } from './utils';

export const BottomPrimaryMenuItemsMobile: FC<BottomPrimaryMenuItemsProps> = ({ onSettingsClick, showVideoAppSelector }) => {
  const { currentCustomer } = useCustomerIdContext();
  const { selectedAppId } = useApplicationWrapperContext();
  const [href, setHref] = useState<string>(getSettingsHref(currentCustomer));

  const onTouch = useCallback(() => {
    setHref(getSettingsHref(currentCustomer));
  }, [currentCustomer]);

  return (
    <>
      <HelpDropdownMenuMobile />
      <PrimaryMenuItemMobile
        data-test-specififier="settings button"
        type="link"
        analyticsMessage="settings"
        analyticsAction="navigate"
        selected={selectedAppId === 'settings'}
        href={href}
        rel="noopener noreferrer"
        onTouchStart={onTouch}
        onClick={onSettingsClick}
      >
        <Settings size={MENU_ITEM_ICON_SIZE} />
      </PrimaryMenuItemMobile>
      <ApplicationsDropdownButtonMobile showVideoAppSelector={showVideoAppSelector} />
      <UserDropdownMenuMobile />
    </>
  );
};
